import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { EmptyDataAreaInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/empty-data-area-info-box';
import { LensBoxMode, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { toBounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/utils';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { taxonomyLensLayout } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/layout';
import { useTaxonomyLensContext } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/use-taxonomy-lens-context';

export function EmptyPositiveAreaInfoBox() {
  const ctx = useTaxonomyLensContext();
  const baseLayout = useCarouselLayout();
  const data = ctx?.data.taxonomyKpis;
  if (!data) {
    return <></>;
  }
  const layout = taxonomyLensLayout(baseLayout, data);
  if (baseLayout.boxMode !== LensBoxMode.MODAL && baseLayout.boxMode !== LensBoxMode.FLOAT) {
    return <></>;
  }
  const ia = layout.impactEuTaxonomyIndicatorBoxesArea(Side.RIGHT, ImpactCategoryId.GHG_EMISSIONS);
  const dataArea = baseLayout.dataArea(Side.RIGHT);

  const y2 = ia.y1 - 6;
  const y1 = dataArea.y1;
  const x1 = dataArea.x1 + 6;
  const x2 = dataArea.x2;
  const bounds = toBounds({ x1, x2, y1, y2 });
  return (
    <EmptyDataAreaInfoBox
      referenceArea={bounds}
      side={Side.RIGHT}
      text="The EU taxonomy only covers environmental impacts"
    />
  );
}
